import {
  AgxBodyText,
  AgxColumn,
  AgxHeader,
  formatCurrency,
  formatNumber,
  formatPercentage,
} from '@urbanx/agx-ui-components';
import { ExecutiveMetrics, ExecutiveMetricsResponse } from '@urbanx/agx.rex.client';
import clsx from 'clsx';

const NetworkTable = ({
  statistics,
  isPending,
}: {
  statistics: ExecutiveMetricsResponse | undefined;
  isPending: boolean;
}) => {
  const { contractType, period, metrics } = statistics || {};

  return (
    <AgxColumn extraClasses="metrics-data">
      <AgxColumn>
        <AgxHeader size={3}>{contractType}</AgxHeader>
        <AgxBodyText medium>{period}</AgxBodyText>
      </AgxColumn>
      <div className="breakeven-table">
        <div className="breakeven-table-header">
          <AgxBodyText extraClasses="breakeven-header left">State</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header left">Listings</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header left">Contracts</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Sales Volume</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Av Sale Price</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">GCI</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Av Comm</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">Service Fee</AgxBodyText>
          <AgxBodyText extraClasses="breakeven-header">% Network</AgxBodyText>
        </div>
        {!isPending &&
          metrics &&
          metrics.map((row, index) => {
            return (
              <NetworkMetricRow key={index} metric={row} totalsRow={index === metrics.length - 1} />
            );
          })}
      </div>
    </AgxColumn>
  );
};

const NetworkMetricRow = ({
  metric,
  totalsRow,
}: {
  metric: ExecutiveMetrics;
  totalsRow: boolean;
}) => {
  const rowClasses = clsx('breakeven-table-row', totalsRow && 'total');

  return (
    <div className={rowClasses}>
      <AgxBodyText medium extraClasses="breakeven-cell left strong">
        {metric.grouping}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell left strong">{metric.listings}</AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell left strong">{metric.contracts}</AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {formatCurrency(metric.salesVolume ?? null, 0)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {formatCurrency(metric.avgSalesPrice ?? null, 0)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {formatCurrency(metric.gci ?? null, 0)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {formatPercentage(metric.avgCommission?.toString() ?? '', 1)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {formatCurrency(metric.serviceFee ?? null, 0)}
      </AgxBodyText>
      <AgxBodyText extraClasses="breakeven-cell strong">
        {metric.percentage === 0 || metric.percentage === 100
          ? metric.percentage
          : formatNumber(metric.percentage?.toString() ?? '', totalsRow ? 0 : 1)}
        %
      </AgxBodyText>
    </div>
  );
};
export default NetworkTable;
